export default __webpack_public_path__ + "static/media/nike.6b5c8a3e.svg";